import './styles.scss'

import React from 'react'

const HandbookIcon = ({ url, className }) => {
  if (!url) return null

  return (
    <a className={`handbook_box ${className || ''}`} href={url} onClick={(e) => e.stopPropagation()} target='_blank' rel='noopener noreferrer'>
      <i className='fa fa-file-pdf-o' />
    </a>
  )
}

export default HandbookIcon
